export const GUESTPRO_URL = process.env.REACT_APP_GUESTPRO_URL;
export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_MSG =
  "Hello Raffiel Nias, I'd like to ask about a room booking.";
export const WA_CARGO_MSG =
  "Hello Raffiel Nias, I'd like to arrange a board bag transfer from Medan/Padang to Nias.";

export const IMAGES = {
  hero: "/images/pool-dusk.jpg",
  room1: "/images/room-deluxe.jpg",
  room2: "/images/room-apartment.jpg",
  room3: "/images/room-standard.jpg",
  gallery1: "/images/wave-deck.jpg",
  gallery2: "/images/pool-dusk.jpg",
  gallery3: "/images/sunset-deck.jpg",
  gallery4: "/images/surf.jpg",
  dining: "/images/restaurant.jpg",
  map: "/images/loungers.jpg",
  transferHero: "/images/transfer-van.jpg",
};
